export default (start: Date, end = new Date()) => (Number(end) - Number(start)) / 1000;
